import Vue from "vue";
import App from "./App.vue";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import ScrollLoader from 'vue-scroll-loader';



import MaterialKit from "./plugins/material-kit";

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

import { Datetime } from 'vue-datetime'
// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'
import { Settings } from 'luxon'

import VueAnalytics from 'vue-analytics';//and then use it in main.js

//import router from "./router";   // Creative Tim routes
import router from './util/router';
import store from './util/store';
import i18n from './util/i18n';

import './util/filters/icon';
import './util/filters/panel-icon';

Vue.config.productionTip = false;

Vue.use(MaterialKit);
Vue.use(Loading);
Vue.use(VueSweetalert2);
Vue.use(ScrollLoader);
Vue.use(Datetime)
Vue.use(require('vue-moment'));

Vue.use(VueAnalytics, {
  id: 'UA-158685659-1',
  router
});


Vue.component('datetime', Datetime);

Settings.defaultLocale = i18n.locale = store.getters['language/current'].locale;

new Vue({
  render: h => h(App),
  el: '#app',
  router,
  store,
  i18n,
  async created() {
    //initialize store data structure by submitting action.
    await this.$store.dispatch('conference/init');
  },
});
